module.exports = __webpack_public_path__ + "assets/img/25@3x.cf742f1f.png";